import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Targets used by this controller
  static targets = ["content", "icon", "toggleButton"]

  static values = {
    defaultExpanded: { type: Boolean, default: true }
  }

  connect() {
    this.applyState(this.defaultExpandedValue)
  }

  toggle() {
    this.applyState(!this.isExpanded())
  }

  expand() {
    this.applyState(true)
  }

  collapse() {
    this.applyState(false)
  }

  isExpanded() {
    if (!this.hasContentTarget) return false
    return !this.contentTarget.classList.contains('hidden')
  }

  applyState(expanded) {
    if (!this.hasContentTarget) return

    this.contentTarget.classList.toggle('hidden', !expanded)

    if (this.hasIconTarget) {
      this.iconTarget.style.transform = expanded ? 'rotate(180deg)' : 'rotate(0deg)'
    }

    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute('aria-expanded', String(expanded))
    }
  }
}